var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMegaphoneAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3507 3.17223L16.2936 3.24219C14.6152 5.29724 12.2121 6.63092 9.59033 7.00501V15.151C12.2121 15.5251 14.6152 16.8588 16.2936 18.9138L16.3507 18.9838C16.6259 19.3208 17.1807 19.1302 17.1807 18.6986V3.4574C17.1807 3.02588 16.6259 2.83527 16.3507 3.17223Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.68956 16.0181C4.40572 16.3467 5.20506 16.5303 6.04818 16.5303H7.65058L7.20117 19.1716C7.11983 19.6497 6.69762 20 6.20289 20H4.20672C3.58134 20 3.10564 19.4499 3.20845 18.8457L3.68956 16.0181Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.04818 7.11267C3.81243 7.11267 2 8.88801 2 11.078C2 13.268 3.81243 15.0433 6.04818 15.0433H8.07227V7.11267H6.04818ZM5.03613 12.0693C4.4772 12.0693 4.02409 11.6255 4.02409 11.078C4.02409 10.5305 4.4772 10.0867 5.03613 10.0867C5.59507 10.0867 6.04818 10.5305 6.04818 11.078C6.04818 11.6255 5.59507 12.0693 5.03613 12.0693Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6619 5.74868C23.0107 5.52091 23.105 5.0593 22.8724 4.71764C22.6399 4.37598 22.1686 4.28365 21.8199 4.51143L18.7837 6.49409C18.4349 6.72186 18.3407 7.18348 18.5732 7.52514C18.8057 7.8668 19.277 7.95912 19.6258 7.73135L22.6619 5.74868Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2048 10.3345C18.7856 10.3345 18.4457 10.6674 18.4457 11.078C18.4457 11.4886 18.7856 11.8215 19.2048 11.8215H22.2409C22.6601 11.8215 22.9999 11.4886 22.9999 11.078C22.9999 10.6674 22.6601 10.3345 22.2409 10.3345H19.2048Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6258 14.4248C19.277 14.197 18.8057 14.2894 18.5732 14.631C18.3407 14.9727 18.4349 15.4343 18.7837 15.6621L21.8199 17.6447C22.1686 17.8725 22.6399 17.7802 22.8724 17.4385C23.105 17.0969 23.0107 16.6352 22.6619 16.4075L19.6258 14.4248Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegaphoneAlt);
export default __webpack_public_path__ + "static/media/megaphone-alt.3c9008b2c39008bd774cf568132b1689.svg";
export { ForwardRef as ReactComponent };